var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('ModalEndPage',{attrs:{"title":_vm.dataToPass.title,"subtitle":_vm.dataToPass.subtitle,"actions":_vm.dataToPass.actions,"main-color":_vm.mainColor,"button-color":_vm.buttonColor}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }